import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/invoiceReminderRecipients`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/invoiceReminderRecipients`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/${jobId}/invoiceReminderRecipients`;
